
export const paperSizes = {
    'A4 Portrait': [210, 297, '../dashboard/a4v.png'],
    'A4 Landscape': [297, 210, '../dashboard/a4h.png'],
    'B4 Portrait': [250, 353, '../dashboard/b4v.png'],
    'B4 Landscape': [353, 250, '../dashboard/b4h.png'],
    'Square': [320, 320, '../dashboard/sq.png'],
    '9x16': [270, 480, '../dashboard/916.png'],
    '3x4': [270, 360, '../dashboard/34.png'],
    'Custom': ''
}

